<template>
  <Dropdown
    ref="dropdown"
    class="min-w-[264px]"
    close-on-click
  >
    <template #trigger="{ toggle, isOpen }">
      <CalendarFilterButton
        :label="label"
        :icon="icon"
        size="lg"
        class="w-full"
        :hide-icon="hideIcon"
        :label-i18n="labelI18n"
        :disabled="disabled"
        @click="toggle"
      >
        <template
          v-if="$slots.icon"
          #icon
        >
          <slot name="icon" />
        </template>

        <template #next-to-label>
          <fa
            class="transition-transform ml-auto"
            icon="chevron-down"
            size="lg"
            :style="{ transform: `rotateX(${isOpen ? '180deg' : '0'})` }"
          />
        </template>

        <template #below-label>
          <span
            class="font-semibold"
            :class="{ 'text-blue-800': isActive }"
          >
            {{ value }}
          </span>
        </template>
      </CalendarFilterButton>
    </template>

    <template #content>
      <div class="bg-white min-w-full">
        <slot />
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },

  value: {
    type: String,
    required: true,
  },

  icon: {
    type: [String],
    required: true,
  },

  isActive: {
    type: Boolean,
    required: true,

  },

  hideIcon: {
    type: Boolean,
    default: false,
  },

  labelI18n: {
    type: String,
    default: null,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
})

const dropdownRef = useTemplateRef('dropdown')

defineExpose({
  hide: () => dropdownRef.value?.hide(),
})
</script>